import classNames from 'classnames';
import { SearchIcon } from 'components/icons/SearchIcon';
import { useLocale } from 'containers/App/LocaleContext';
import { useEffect, useRef } from 'react';
import type { ChangeEvent, FC } from 'react';

interface Props {
  setValue: (value: string) => void;
  value: string;
}

export const GraphLoadViewField: FC<Props> = (props) => {
  const {
    canvasGraph: {
      commands: { loadView: loadViewMsg },
    },
  } = useLocale();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.setValue(e.target.value);
  };

  return (
    <div className='graph-load-view__field'>
      <SearchIcon title={null} width={16} height={16} />
      <input
        type='text'
        className={classNames('graph-load-view__field-input')}
        placeholder={loadViewMsg.searchViews}
        ref={inputRef}
        value={props.value}
        onChange={handleChange}
      />
    </div>
  );
};
